
const staticRoutes = [
  {
    path: '/',
    redirect: 'login'
  },
  {
    path: '/login',
    component: () => import('../page/login')
  },
  {
    path: '/index',
    component: () => import('../page/index')
  },
  {
    path: '/audit/profit',
    component: () => import('../page/audit/profit')
  },
  {
    path: '/audit/patent',
    component: () => import('../page/audit/patent')
  },
  {
    path: '/audit/patent/modify',
    component: () => import('../page/audit/patentModify')
  },
  {
    path: '/audit/patent/seal',
    component: () => import('../page/audit/patentSeal')
  },
  {
    path: '/audit/soft',
    component: () => import('../page/audit/soft')
  },
  {
    path: '/audit/soft/modify',
    component: () => import('../page/audit/softModify')
  }
];

export default staticRoutes;
